import React from 'react';

import {
    Button
    , Modal
    , ModalBody
} from 'reactstrap';
import './InfoModal.css'

type IModalProps = {
    text?: string,
    html?: React.ReactNode
    modalClass?: string,
    isOpen: boolean,
    actionButtonText?: string;
    action?: () => void;
    closeButtonText?: string;
    closeAction?: () => void;
}

const RootModal = (props: IModalProps) => {

    const closeModal = () => {
        if (props.closeAction) props.closeAction();
    }

    const closeText = props.closeButtonText || "OK";

    const closeButtonClass = `${ props.actionButtonText ? 'btn-secondary' : 'btn-primary' }  pr-4 pl-4 mb-5`;

    return (
        <React.Fragment>
            <Modal
                isOpen={props.isOpen}
                className={`info-modal-text ${props.modalClass}`}
            >
                <ModalBody className="text-center pb-5 pt-5">
                    {props.text ? <div className="inner-text">{props.text}</div> : <></>}
                    {props.html ? props.html : <></>}
                </ModalBody>
                <div className="pb-3" style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button className={closeButtonClass} onClick={closeModal}>{closeText}</Button>
                    {props.actionButtonText ? <Button className='btn-primary pr-4 pl-4 mb-5 ml-4' onClick={props.action}>{props.actionButtonText}</Button> : <React.Fragment />}
                </div>
            </Modal >
        </React.Fragment>
    )
};


const InfoModal = (props: {
    text?: string,
    html?: React.ReactNode,
    modalClass?: string,
    closeAction?: () => void,
    isOpen: boolean
}) => (<RootModal {...props} />);


export const ExitCancelModel = (props: {
    text: string,
    isOpen: boolean,
    actionButtonText: string,
    action: () => void,
    closeButtonText: string,
    closeAction?: () => void
}) => (<RootModal {...props} />);

export default InfoModal
